<template>
  <div>
    <v-container >
      <v-row class="elevation-1">
        <v-col>
          <v-select id="input-text-size"
          class="input-text-size"
            v-model="reportConfig"
            :items="reports"
            item-text="description"
            item-value="config"
            label="Type of report"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showDates')">
        <v-col cols="6">
          <ClarionDateControl
            v-model="criteria.fromDate"
            label="From Date"
            class="input-text-size"
            :isToggle = "false"
            />
        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            v-model="criteria.toDate"
            label="To Date"
            class="input-text-size"
            :isToggle = "false"
            />

        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showTaxYears')">
        <v-col cols="6">
          <v-select
                class="input-text-size"
                :items="taxYearList"
                label="From Tax Year"
                item-text="name"
                item-value="value"
                v-model.number="criteria.fromTaxYear"
              ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
          class="input-text-size"
                :items="taxYearList"
                label="To Tax Year"
                item-text="name"
                item-value="value"
                v-model.number="criteria.toTaxYear"
              ></v-select>

        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showCurrentTaxYear')">
        <v-col cols="6">
          <v-select
            class="input-text-size"
            :items="taxYearList"
            label="Current Tax Year"
            hint="Compared against the previous tax year (Current − 1)"
            persistent-hint
            item-text="name"
            item-value="value"
            v-model.number="criteria.currentTaxYear"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showIncludeUnchanged')
          || showReportConfig('showIncludeNewParcels')">
        <v-col cols="4" v-if="showReportConfig('showIncludeUnchanged')">
          <v-checkbox
            v-model="criteria.includeUnchanged"
            label="Show No-Change Records"
            class="input-text-size pt-2">
          </v-checkbox>
        </v-col>
        <v-col cols="4" v-if="showReportConfig('showIncludeNewParcels')">
          <v-checkbox
            v-model="criteria.includeNewParcels"
            label="Flag New Parcels (no previous year)"
            class="input-text-size pt-2">
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showWorkstation')">
        <v-col>
          <SimpleMultiSelect
            id="tmc-tax-payment-by-wkst"
            label="By Workstation"
            :items="criteria.wkst"
            :item-list="wkstNumList"
            @selected-items="selectedWkstList"
          />
          </v-col>
      </v-row>
      <v-row class="elevation-1">
        <v-col cols="3"
          id="tmc-tax-overpayment-show-assign"
          v-if="showReportConfig('showAssignedUser')">
          <MultiItemSelect
          class="input-text-size"
            label="By Assign To"
            item-text="fullname"
            item-value="fullname"
            :item-list="assignUsersList"
            :items="criteria.assignedTo"
            @selected-items="selectedUsers"
          />

        </v-col>
        <v-col cols="2"
          id="tmc-tax-overpayment-show-unresolved"
          v-if="showReportConfig('showUnresolved')">
          <v-checkbox
            v-model="criteria.showUnresolved"
            label="Show Unresolved Only"
            class="input-text-size pt-4">
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row class="elevation-1">
        <v-col cols="6" v-if="showReportConfig('showTaxTypes')">
              <MultiItemSelect
                class="input-text-size"
                  label="Tax Type"
                  item-text="name"
                  item-value="value"
                  :item-list="taxTypes"
                  :items="criteria.taxType"
                  @selected-items="selectedTaxTypes"
                />
        </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showTaxDistricts')"
        >
        <v-col>
          <MultiItemSelect
          class="input-text-size"
            label="By Tax Districts"
            item-text="taxDistrictCodeAndName"
            item-value="districtCode"
            :item-list="taxDistrictList"
            :items="criteria.taxDistricts"
            @selected-items="selectedTaxDistricts"
          />

          </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showReasonCode')"
        >
        <v-col>
          <MultiItemSelect
          class="input-text-size"
            label="By Reason Code"
            item-text="name"
            item-value="value"
            :item-list="reasonCodeList"
            :items="criteria.reasonCodes"
            @selected-items="selectedReasonCodes"
          />

          </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showTitle')">
        <v-col>
          <v-text-field
           small
           hide-details
           dense
           label="Title"
           v-model="criteria.titleToPrint"
           class="input-text-size">
          </v-text-field>
          </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showPageBreakdownYears')">
        <v-col>
          <v-checkbox
          class="input-text-size"
            v-model="criteria.pageBreakdown"
            label="Page Breakdown Years">
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showExcludeSpecialAssessmentDistricts')">
        <v-col>
          <v-checkbox
          class="input-text-size"
            v-model="criteria.excludeSpecialAssessmentDistricts"
            label="Exclude Special Assessment Districts">
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showOnlySpecialAssessmentDistricts')">
        <v-col>
          <v-checkbox
          class="input-text-size"
            v-model="criteria.onlySpecialAssessmentDistricts"
            label="Special Assessment Districts Only">
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showAsOfDate')">
        <v-col>
          <v-col id="">
          <ClarionDateControl
            v-model="criteria.asOfDate"
            label="As of Date "
            class="input-text-size"
            :isToggle = "false"
            />
        </v-col>
        </v-col>
      </v-row>

      <v-row class="elevation-1">
        <v-col cols="2"
          id="tmc-misc-report-print-details"
          v-if="showReportConfig('showPrintDetails')">
          <v-checkbox
            v-model="criteria.printDetails"
            label="Print Details"
            class="input-text-size">
          </v-checkbox>
        </v-col>
        <v-col cols="4"
          id="tmc-misc-report-print-details"
          v-if="showReportConfig('syncWithTaxrollSummary') && isSuperAdmin">
          <v-checkbox
            v-model="criteria.syncWithTaxrollSummary"
            label="Sync With Taxroll Summary"
            class="input-text-size">
          </v-checkbox>
        </v-col>
        <v-col cols="2"
          id="tmc-misc-report-print-full-desc"
          v-if="showReportConfig('showPrintFullDesc')">
          <v-checkbox
            v-model="criteria.printFullDesc"
            label="Print Full Desc."
            class="input-text-size">
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="showReportConfig('showTypeOfCollectionSummary')">
          <v-radio-group
            v-model="criteria.reportPrintPattern"
            row
            mandatory
          >
            <template v-slot:label  >
              <div><h3 class="input-text-size">Select Type of Taxroll Summary: </h3></div>
            </template>
            <v-radio
              label="One Page Summary"
              value="onePageSummary"
              class="input-text-size"
            ></v-radio>
            <v-radio
              label="Year By Year Summary"
              value="yearByYearSummary"
              class="input-text-size"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row>
        <ReportChip
          :to="reportConfig.route"
          :queryString="queryString"
          :isValid="validateCriteria"
          caption="View Report"
        />
        <AddToCronJobBtn
          v-if="reportConfig.route"
          :destination="reportConfig.route"
          :params="currentCronParams"
          class="ml-2 mt-1"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ReportChip from '../../../reports/ReportChip.vue';
import AddToCronJobBtn from '../../../common/AddToCronJobBtn.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import { reportList, queryStringCalc, blankAllSelectedLists } from './report-util';
import { getRawJwt } from '../../../../util/jwt';
import MultiItemSelect from '../../../common/base/MultiItemSelect.vue';
import { typesDefination } from '../util';
import { toShortDate } from '../../../../util/shared/tmc-global';
import {
  taxReasonListDropDownPostProcessTrans,
} from '../../common-utils/CommonTaxFunctionalities';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import SimpleMultiSelect from '../../../common/base/SimpleMultiSelect.vue';
import { isAuthorised } from '../../../../store/auth/token';
import { authRoles } from '../../../../router/roleGroups';

const taxDistrictBaseCrudKey = 'sharedTaxDistrict';

export default {
  name: 'TaxInquiryReportComp',
  components: {
    ReportChip,
    ClarionDateControl,
    MultiItemSelect,
    SimpleMultiSelect,
    AddToCronJobBtn,
  },
  data: () => ({
    wkstNumber: getWorkstationNumber(),
    miscBaseCrudKey: 'miscTransaction',
    taxYearRange: [],
    criteria: {
      asOfDate: undefined,
      fromTaxYear: undefined,
      toTaxYear: undefined,
      currentTaxYear: undefined,
      includeUnchanged: false,
      includeNewParcels: false,
      taxDistricts: [],
      printDetails: false,
      printFullDesc: false,
      syncWithTaxrollSummary: false,
      titleToPrint: '',
      reportPrintPattern: undefined,
      wkst: [],
      taxYears: [],
      taxType: [],
      assignedTo: [],
      fromDate: toShortDate(),
      toDate: toShortDate(),
      reasonCodes: [],
    },
    reportConfig: {
      route: '',
      filters: {},
    },
    criteriaStats: {
      allTaxDistricts: false,
      allTaxTypes: false,
      allReasonCodes: false,

    },
    defaultCriteria: {
      fy: undefined,
    },
    taxYearsList: [],
    userList: [],
    assignUsersList: [],
    taxTypes: [],
  }),
  created() {
    this.criteria.asOfDate = toShortDate(this.todaysDate);
    this.loadTaxDistricts();
    this.initializeTaxYear();
    this.loadUsersList();
    this.loadTaxTypes();
    this.loadWorkStationNumbers();
    this.loadReasonCodeList();
  },

  watch: {
    'reportConfig.route': function reportRouteChanged() {
      if (this.reasonCodeList.length) {
        this.applyDefaultReasonCodes();
      }
    },
    'criteria.excludeSpecialAssessmentDistricts': function excludeSAChanged(val) {
      if (val) {
        this.criteria.onlySpecialAssessmentDistricts = false;
      }
    },
    'criteria.onlySpecialAssessmentDistricts': function onlySAChanged(val) {
      if (val) {
        this.criteria.excludeSpecialAssessmentDistricts = false;
      }
    },
  },

  computed: {
    ...mapGetters('base/crud', [
      'items',
    ]),
    ...mapState({
      taxYearList: (state) => state.tax.taxCommon.taxYearList,
      wkstNumList: (state) => state.tax.taxPayment.paymentWkstNumList || [],
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
    }),
    reports() {
      return [
        ...reportList(),
      ];
    },
    wkstIdLists() {
      const wkstNoList = (this.wkstNumList || []);
      return wkstNoList;
    },
    taxDistrictList() {
      const items = this.items(taxDistrictBaseCrudKey);
      const updatedItem = items.map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [...updatedItem];
    },
    reasonCodeList() {
      const items = this.items('reasonListDropDown');
      const updatedItem = items.filter((i) => i.value !== null);
      return [...updatedItem];
    },
    queryString() {
      return queryStringCalc({
        reportConfig: this.reportConfig,
        params: this.buildCriteriaParams(),
        token: this.getAuthToken,
        devSetting: this.devSettingItem,
      });
    },
    validateCriteria() {
      let isValid = true;
      if (this.criteria.fy == null) {
        isValid = false;
      }
      return isValid;
    },
    getAuthToken() {
      return getRawJwt();
    },
    isVoidOptions() {
      return [
        {
          value: null,
          caption: 'All',
        },
        {
          value: true,
          caption: 'Void',
        },
      ];
    },
    isSuperAdmin() {
      // only super admin can sync with taxroll summary
      return isAuthorised(authRoles.SuperAdmin);
    },
    currentCronParams() {
      // TKT-001085: a saved job keeps "all districts" as a blank, so districts added later are
      // in it. Only the cron copy is blanked - the View Report chip above still spells out the
      // codes it is printing.
      return blankAllSelectedLists(this.buildCriteriaParams(), this.criteriaStats);
    },
  },
  methods: {
    buildCriteriaParams() {
      const c = this.criteria;
      const s = this.criteriaStats;
      return {
        fromDate: c.fromDate,
        toDate: c.toDate,
        asOfDate: c.asOfDate,
        issueDate: c.issueDate,
        fromTaxYear: c.fromTaxYear,
        toTaxYear: c.toTaxYear,
        currentTaxYear: c.currentTaxYear,
        includeUnchanged: c.includeUnchanged,
        includeNewParcels: c.includeNewParcels,
        taxDistrictCodes: (c.taxDistricts || []).join(','),
        workstation: (c.wkst || []).join(','),
        reasonCodes: (c.reasonCodes || []).join(','),
        taxYears: (c.taxYears || []).join(','),
        taxTypes: (c.taxType || []).join(','),
        printDetails: c.printDetails,
        syncWithTaxrollSummary: c.syncWithTaxrollSummary,
        printFullDesc: c.printFullDesc,
        pageBreakdown: c.pageBreakdown,
        titleToPrint: c.titleToPrint,
        reportPrintPattern: c.reportPrintPattern,
        unresolved: c.showUnresolved,
        assigned: (c.assignedTo || []).join(','),
        adjustmentCodes: (c.adjTypes || []).join(','),
        fullDetails: c.showFullDetails,
        allSATaxdistrict: c.allSATaxdistrict,
        excludeSpecialAssessmentDistricts: c.excludeSpecialAssessmentDistricts,
        onlySpecialAssessmentDistricts: c.onlySpecialAssessmentDistricts,
        allWkst: s.allWkst,
        allTaxDistricts: s.allTaxDistricts,
        allTaxTypes: s.allTaxTypes,
        allReasonCodes: s.allReasonCodes,
      };
    },
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapActions('tax/taxCommon', [
      'loadTaxYearList',
    ]),
    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    ...mapActions('UserAdministration', [
      'loadUsers',
    ]),
    ...mapActions('tax/taxRollAdjustments', [
      'getTaxTypes',
    ]),
    ...mapActions('shared/taxReasonCode', [
      'loadReasonCode',
    ]),
    ...mapActions('tax/taxPayment', [
      'loadPaymentsWkstList',
    ]),
    async loadWorkStationNumbers() {
      await this.loadConfig({ requiredScope: 'paymentConfig' });
      this.loadPaymentsWkstList().then(() => {
        this.criteria.wkst = this.wkstIdLists;
        this.criteriaStats.allWkst = true;
        // Load excluded workstations after payment config is loaded
        this.loadExcludedWorkstations();
      });
    },
    selectedWkstList(val) {
      this.criteria.wkst = val;
      /* update stats */
      this.criteriaStats.allWkst = (val || []).length === this.wkstIdLists.length;
    },
    selectedTaxTypes(val) {
      this.criteria.taxType = val;
      /* update stats */
      this.criteriaStats.allTaxTypes = (val || []).length === this.taxTypes.length;
    },
    async loadUsersList() {
      const users = await this.loadUsers();
      const taxUsers = [];
      // eslint-disable-next-line array-callback-return, consistent-return
      (users || []).map((item) => {
        const { roles } = item;
        if (roles.includes('TAXADMINISTRATION') || roles.includes('TAXUSER')) {
          taxUsers.push({ fullname: item.fullname });
        }
      });
      taxUsers.sort((a, b) => (a.fullname || '').localeCompare(b.fullname || ''));
      this.assignUsersList = taxUsers;
      // MultiItemSelect is bound item-value="fullname" - criteria.assignedTo must hold the
      // matching value strings, not the {fullname} objects themselves.
      this.criteria.assignedTo = taxUsers.map((u) => u.fullname);
    },
    mapCollectionVal(itemList, itemValue) {
      return [...(itemList || []).map((item) => item[`${itemValue}`])];
    },

    selectedTaxDistricts(val) {
      this.criteria.taxDistricts = val;
      /* update stats */
      this.criteriaStats.allTaxDistricts = (val || []).length === this.taxDistrictList.length;
    },

    selectedReasonCodes(val) {
      this.criteria.reasonCodes = val;
      /* update stats */
      this.criteriaStats.allReasonCodes = (val || []).length === this.reasonCodeList.length;
    },

    selectedTaxYears(val) {
      this.criteria.taxYears = val;
    },
    selectedUsers(val) {
      this.criteria.assignedTo = val;
    },
    showReportConfig(configField) {
      return this.reportConfig.filters[`${configField}`];
    },

    loadTaxDistricts() {
      const criteria = {};
      this.loadTaxDistrict({ criteria, baseCrudKey: taxDistrictBaseCrudKey }).then(() => {
        this.criteria.taxDistricts = this.mapCollectionVal(this.taxDistrictList, 'districtCode');
        /* Set select-all */
        this.criteriaStats.allTaxDistricts = true;
      });
    },
    loadReasonCodeList() {
      this.loadReasonCode({
        criteria: {},
        postProcessTrans: taxReasonListDropDownPostProcessTrans,
        baseCrudKey: 'reasonListDropDown',
      }).then(() => {
        this.applyDefaultReasonCodes();
      });
    },
    applyDefaultReasonCodes() {
      const excluded = (this.reportConfig.filters || {}).defaultExcludeReasonCodes || [];
      this.criteria.reasonCodes = this.mapCollectionVal(this.reasonCodeList, 'value')
        .filter((code) => !excluded.includes(code));
      /* Set select-all only when nothing is excluded by default */
      this.criteriaStats.allReasonCodes = excluded.length === 0;
    },
    async initializeTaxYear() {
      const item = await this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      const data = [];
      const taxYears = [];
      item.forEach((val) => {
        data.push({
          taxYear: val,
        });
        taxYears.push(val);
      });
      if ((taxYears || []).length > 0) {
        this.taxYearsList = data;
        this.criteria.fromTaxYear = (taxYears[0] || {});
        this.criteria.toTaxYear = (taxYears[0] || {});
        this.criteria.currentTaxYear = (taxYears[0] || {});
        this.criteria.taxYears = taxYears;
      }
    },
    async loadTaxTypes() {
      const tt = await this.getTaxTypes();
      const updatedItem = [];
      const taxType = [];
      // eslint-disable-next-line array-callback-return
      for (const item of tt) {
        if (item) {
          updatedItem.push({
            name: `${item.toUpperCase()} - ${typesDefination[item] || ''} `, value: item.toUpperCase(),
          });
          taxType.push(item.toUpperCase());
        }
      }
      this.criteria.taxType = taxType;
      /* update stats */
      this.criteriaStats.allTaxTypes = true;
      this.taxTypes = updatedItem;
    },
    loadExcludedWorkstations() {
      // Initialize excluded workstations with the ones from paymentSetting
      // This will show all workstations but have the excluded ones pre-selected
      if (this.paymentSettingItem.excludeWkst && this.paymentSettingItem.excludeWkst.length > 0) {
        this.criteria.excludedWkst = [...this.paymentSettingItem.excludeWkst];
      } else {
        this.criteria.excludedWkst = [];
      }
    },
  },
};

</script>
